var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlusCircleGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3c7.18 0 13 5.82 13 13a13 13 0 0 1-6.139 11.042l-.361.216A13 13 0 0 1 3 16C3 8.82 8.82 3 16 3zm0 2C9.925 5 5 9.925 5 16a11 11 0 0 0 22 0l-.005-.336c-.174-5.808-4.85-10.485-10.659-10.659L16 5zm0 6a1 1 0 0 1 1 1v2.999L20 15a1 1 0 0 1 .99.864L21 16a1 1 0 0 1-1 1l-3-.001V20a1 1 0 0 1-.864.99L16 21a1 1 0 0 1-1-1v-3.001L12 17a1 1 0 0 1-.99-.864L11 16a1 1 0 0 1 1-1l3-.001V12a1 1 0 0 1 .864-.99L16 11z",
    fill: "#92ECD5",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusCircleGreen);
export default __webpack_public_path__ + "static/media/icon-plus-circle-green.c5a53063d2199d912d427bd8623645a5.svg";
export { ForwardRef as ReactComponent };